import MainController from 'main.controller';
import 'main.styles.css';

export default {
	templateUrl: 'src/main.template.html',
	controller: MainController
};